import { useState, useEffect, useCallback, lazy, Suspense } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import TransformationSection from './components/TransformationSection';
import BenefitsSection from './components/BenefitsSection';
import Divider from './components/Divider';

// Lazy load de seções abaixo da dobra
const ContentSection = lazy(() => import('./components/ContentSection'));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection'));
const OfferSection = lazy(() => import('./components/OfferSection'));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection'));
const FAQSection = lazy(() => import('./components/FAQSection'));
const FinalCTASection = lazy(() => import('./components/FinalCTASection'));

export default function HomePage() {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    if (document.fonts) {
      document.fonts.ready.then(() => {
        setFontsLoaded(true);
      });
    } else {
      setFontsLoaded(true);
    }
  }, []);

  const scrollToOffer = useCallback(() => {
    document.getElementById('oferta')?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  const handlePurchase = useCallback(() => {
    window.open('https://pay.kiwify.com.br/SrTJuLO', '_blank');
  }, []);

  return (
    <div className="min-h-screen bg-black text-white overflow-x-hidden">
      <Header onScrollToOffer={scrollToOffer} />
      <HeroSection onScrollToOffer={scrollToOffer} />
      <Divider />
      <ProblemSection />
      <Divider />
      <TransformationSection />
      <Divider />
      <BenefitsSection />
      <Divider />
      
      <Suspense fallback={<div className="h-screen bg-black" />}>
        <ContentSection />
        <Divider />
        <TestimonialsSection />
        <Divider />
        <OfferSection handlePurchase={handlePurchase} />
        <Divider />
        <GuaranteeSection />
        <Divider />
        <FAQSection handlePurchase={handlePurchase} />
        <Divider />
        <FinalCTASection handlePurchase={handlePurchase} />
      </Suspense>

      <footer className="relative py-6 sm:py-8 bg-black border-t border-yellow-500/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <p className="text-gray-500 text-xs sm:text-sm">
            © 2025 O Código da Mentalidade Milionária. Todos os direitos reservados.
          </p>
        </div>
      </footer>
    </div>
  );
}
